import React from 'react';
import { Alert, Button, Container } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
          <Alert variant="danger" className="text-center" style={{ maxWidth: 480 }}>
            <Alert.Heading>Something went wrong</Alert.Heading>
            <p className="mb-3 small text-muted">
              {this.state.error?.message || 'An unexpected error occurred.'}
            </p>
            <Button variant="outline-danger" onClick={() => window.location.reload()}>
              Reload page
            </Button>
          </Alert>
        </Container>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
